import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TeamService} from "../service/team.service";
import {ReservedQrsService} from "../service/reserved-qrs-service";
import {ReservedQrsConnectRequest} from "../models/ReservedQrsConnectRequest";
import {MockupDataModel} from "../qr-copy-message/mockup-data.model";
import {SnackBarUtil} from "../qr-copy-message/snack-bar-util.service";
import {CARD_MESSAGES} from "../constants/card-connect.constants";
import {HttpErrorResponse} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-connect-reserved-qr',
  templateUrl: './connect-reserved-qr.component.html',
  styleUrl: './connect-reserved-qr.component.scss'
})
export class ConnectReservedQrComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) protected data: { cardId: number; reservedIdentificationId: string },
    protected dialogRef: MatDialogRef<ConnectReservedQrComponent>,
    private reservedQrsService: ReservedQrsService,
    private snackBar: SnackBarUtil,
    private translate: TranslateService,
  ) {
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submitSelection(): void {
    const request: ReservedQrsConnectRequest = {
      cardId: this.data.cardId,
      reservedIdentificationId: this.data.reservedIdentificationId
    };
    this.reservedQrsService.connectNewReservedQr(request).subscribe({
      next: () => {
        this.handleDialogClose(true, this.translate.instant(CARD_MESSAGES.SUCCESS), SnackBarUtil.CLASSES.success);
      },
      error: (error: HttpErrorResponse) => {
        this.handleDialogClose(false, this.translate.instant(CARD_MESSAGES.ERROR), SnackBarUtil.CLASSES.error);
      }
    });
  }

  private handleDialogClose(success: boolean, message: string, cssClass: string | string[]): void {
    this.dialogRef.close(success);
    const data = success
        ? MockupDataModel.success(message)
        : MockupDataModel.error(message);
    this.showSnackbar(data, cssClass);
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string | string[]): void {
    this.snackBar.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data,
    });
  }
}
